'use strict';

import MapProperty from '../private/IMapProperty';

/**
 * @description array of each field & how to convert between external(api) & internal representations
 */
const MAPPINGS: Array<MapProperty> = [
    {
        localName: 'id',

        defaultValue: 0,
    },
    {
        localName: 'tourId',

        defaultValue: 0,
    },
    {
        localName: 'elementOrder',

        defaultValue: 0,
    },
    {
        localName: 'siteObjectId',

        defaultValue: 0,
    },
    {
        localName: 'menuItemId',

        defaultValue: 0,
        optional: true,
    },
    {
        localName: 'parentTourRelatedSiteObjectId',

        defaultValue: 0,
        optional: true,
    },
];

export default MAPPINGS;
